const MoveInFeedbackListing = ({ isMultiFamily = false, address = '', listingAlias = '' } = {}) => {
  return {
    isMultiFamily: Boolean(isMultiFamily),
    address: String(address),
    listingAlias: String(listingAlias),
  };
};

export default MoveInFeedbackListing;
